module.exports = __webpack_public_path__ + "static/media/Connectmng.aec438c6.webp";